import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
import { Grid } from '@material-ui/core';
export const StyledLoadingWrapper = styled(Grid) `
	height: 100%;
	background-color: ${(props) => props.bgcolor};
	text-align: center;
	padding: 0 ${Magnetic.spacer20};
	position: absolute;
`;
export const StyledLogo = styled('img') `
	margin-bottom: ${Magnetic.spacer20};
	width: 150px;
`;
export const StyledLoadingText = styled('h1') `
	font-size: ${Magnetic.fontSize16};
	color: ${Magnetic.colorWhite};
	margin-bottom: ${Magnetic.spacer20};

	&:nth-of-type(2) {
		font-weight: ${Magnetic.fontWeightSemibold};
	}
`;
export const StyledAnimatedDots = styled('span') `
	&:after {
		content: '';
		display: inline-block;
		width: 1em;
		text-align: left;
		animation: dots 1.5s steps(3, end) infinite;
	}

	@keyframes dots {
		0% {
			content: '';
		}
		33% {
			content: '.';
		}
		66% {
			content: '..';
		}
		100% {
			content: '...';
		}
	}
`;
//# sourceMappingURL=IntelligentProgressLoader.style.js.map